/* eslint-disable */
import { Button } from '@mui/material';
// eslint-disable-next-line object-curly-newline
import { useEffect, useMemo, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { CheckPicker } from 'rsuite';
import analyticsAction from '../../Actions/analytics.actions';
import SearchBar from '../../Components/SearchBar/SearchBar';
import analyticsTypeConstant from '../../Constants/analyticsType.contants';
// eslint-disable-next-line object-curly-newline
import {
	filtersInfoChip,
	usePagination,
	useQuery,
	useSearch,
	formatNumber,
	formatQuantityWithLakhsCrores,
	getHigherUnitAndQuantity,
} from '../../Helpers';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { urls } from '@/Constants';
import styles from './INVHistory.module.scss';
import Calender from '../../Components/Forms/Payment Settlements/Calender/Calender';
import { formActions, modalActions } from '../../Actions';
import { BackdropLoader } from '../../Components/Loaders';
import aiAnalyticsActions from '../../Actions/aiAnalytics.actions';
import InvAnalysisListPage from './INVAnalysisListPage';
import moment from 'moment';
import { ExternalLink, Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import StatsComp from '../ProductionAnalysis/StatsComp';
import { number } from 'prop-types';

const ANALYTICS_TYPE = analyticsTypeConstant.INV_HISTORY_LIST_DATA;

const PLACE_HOLDERS = {
	PRODUCT_NAME: 'Search by Product Name',
};

const SEARCH_BY = {
	options: [
		{
			key: 'productName',
			title: 'Product Name',
			get: 'ProductName',
		},
	],
};

const filtersInfo = {
	header: {
		store: false,
		date: false,
	},
	store: {
		text: 'Select Store',
		show: true,
		multiSelect: true,
		noAllOption: true,
	},
	dateRangeOnly: {
		show: true,
	},
};

const exportInfo = {
	showExportBtn: true,
};
const INVHistory = (props) => {
	const {
		dateRangeFilter,
		data,
		setDateRangeFilter,
		fetchData,
		setBomSearchResults,
		searchQuery,
		searchBy,
		gateway,
		toggleFiltersDrawer,
		exportInvAnalytics,
	} = props;

	const [loading, setLoading] = useState(false);
	const [selectedTab, setSelectedTab] = useState('weight');
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const [filtersValue, setFiltersValue] = useState({});
	const [format, setFormat] = useState('dateWise');

	const [trailData, setTrailData] = useState([]);

	const fetchInventoryData = async (filters, currentFormat = format) => {
		setFiltersValue(filters);
		setLoading(true);
		try {
			const payload = {
				data: {
					dateRangeFilter: {
						from: moment(
							filters?.dateRange?.from || new Date()
						).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to || new Date()).format(
							'YYYY-MM-DD'
						),
					},
					stores: filters?.multiStore?.id
						? filters?.multiStore?.id
						: [],
					format: currentFormat,
				},
			};

			const response =
				currentFormat === 'productWise'
					? await inventoryAnalyticsServices.variantWiseSkuTrail(
							payload
					  )
					: await inventoryAnalyticsServices.dayWiseSkuTrail(payload);
			if (response?.responseCode === 'SS-001') {
				setTrailData(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
			setTrailData([]);
		} finally {
			setLoading(false);
		}
	};

	const queryParams = useQuery();
	const {
		query,
		handleSearch,
		clearSearch,
		searchBy: searchField,
		handleSearchBy: setSearchField,
	} = useSearch(
		searchQuery,
		SEARCH_BY?.options?.findIndex((option) => {
			return option.key === searchBy;
		}) ?? 0
	);

	useEffect(() => {
		if (queryParams.has('clear')) {
			clearSearch();
			setSearchField(0);
			setBomSearchResults('', data, 'productName');
		}
	}, [queryParams]);

	const generateData = () => {
		let filteredData = trailData || [];

		// Filter by search query on product name
		if (query?.trim()) {
			filteredData = filteredData.filter((obj) => {
				const productName = obj?.product?.productName ?? '';
				return (
					productName
						.toLowerCase()
						.indexOf(query.trim().toLowerCase()) !== -1
				);
			});
		}

		setBomSearchResults(
			query,
			filteredData,
			SEARCH_BY?.options?.[searchField]?.key
		);
		return filteredData;
	};

	const handleSearchBy = (index) => {
		setSearchField(index);
	};

	const handleFilterDrawerOpen = () => {
		toggleFiltersDrawer(true, {
			handleDataExport: (filters) => {
				const apiFilters = {
					dateRangeFilter: {
						from: moment(
							filters?.dateRange?.from || new Date()
						).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to || new Date()).format(
							'YYYY-MM-DD'
						),
					},
					storeFilter: filters?.multiStore?.id
						? filters?.multiStore?.id
						: [],
					format: format,
				};
				exportInvAnalytics(apiFilters);
			},
		});
	};

	const currentData = generateData();

	const statsSummary = useMemo(() => {
		let openingStock = 0;
		let totalStockIn = 0;
		let externalStockIn = 0;
		let recipeConsumption = 0;
		let production = 0;
		let totalStockOut = 0;
		let internalStockOut = 0;
		let expired = 0;
		let closingStock = 0;

		const isCost = selectedTab === 'cost';
		const COUNT_UNITS = ['pc', 'count', 'piece', 'pieces', 'pcs'];

		// Helper: for weight mode, if unit is count/pcs, multiply qty by minWeight (in g)
		const getWeightValue = (item, rawValue) => {
			const unit = item?.product?.unit ?? '';
			if (COUNT_UNITS.includes(unit?.toLowerCase())) {
				const minWeight = item?.productVariant?.minWeight;
				if (minWeight && minWeight > 0) {
					return (rawValue || 0) * minWeight;
				}
				return 0;
			}
			return rawValue || 0;
		};

		// Helper: for cost mode, multiply qty by price
		const getCostValue = (item, rawValue) => {
			return (
				(getHigherUnitAndQuantity(
					item?.product?.unit,
					rawValue,
					true
				)[0] || 0) * (item?.price ?? 0)
			);
		};

		const getValue = (item, rawValue) => {
			if (isCost) return getCostValue(item, rawValue);
			return getWeightValue(item, rawValue);
		};

		(currentData || []).forEach((item) => {
			openingStock += getValue(item, item.openingStock);
			totalStockIn += getValue(item, item.totalStockIn);
			externalStockIn += getValue(item, item.externalStockIn);
			recipeConsumption += getValue(item, item.recipeConsumption);
			production += getValue(item, item.production);
			totalStockOut += getValue(item, item.totalStockOut);
			internalStockOut += getValue(item, item.internalStockOut);
			expired += getValue(item, item.expired);
			closingStock += getValue(item, item.closingStock);
		});

		const formatWeightNum = (num, conversionType = 'IN') => {
			if (isNaN(num)) return `0 g`;
			const options = [
				{ divisor: 1000000000000, unit: 'MT' },
				{ divisor: 1000000000, unit: 'KT' },
				{ divisor: 1000000, unit: 'T' },
				{ divisor: 1000, unit: 'kg' },
				{ divisor: 1, unit: 'g' },
			];
			const formatted = options.find(({ divisor }) => num >= divisor);
			if (formatted) {
				const formatValue = num / formatted.divisor;
				return `${formatNumber(conversionType, formatValue)} ${
					formatted.unit
				}`;
			}
			return `${formatNumber(conversionType, num)} g`;
		};

		const formatCostNum = (num) => {
			if (isNaN(num)) return '₹0';
			console.log(num, 'lakhCrores', formatQuantityWithLakhsCrores(num));
			return `₹${formatQuantityWithLakhsCrores(num)}`;
		};

		// For count tab, format as "X pcs | Y kg"
		const formatCountNum = (weightNum, pcsNum) => {
			const weightStr = formatWeightNum(weightNum);
			if (pcsNum > 0) {
				return `${pcsNum} pcs | ${weightStr}`;
			}
			return weightStr;
		};

		const formatNum = (num) => {
			if (isCost) return formatCostNum(num);
			return formatWeightNum(num);
		};

		return [
			{
				label: 'Opening Stock',
				value: formatNum(openingStock),
				color: '#3b82f6',
			},
			{
				label: 'Material Procured',
				value: formatNum(externalStockIn),
				color: '#8b5cf6',
			},
			{
				label: 'Produced',
				value: formatNum(production),
				color: '#f59e0b',
			},
			{
				label: 'Total Stocked In',
				value: formatNum(totalStockIn),
				color: '#10b981',
			},
			{
				label: 'Material Consumed',
				value: formatNum(recipeConsumption),
				color: '#d946ef',
			},
			{
				label: 'Dispatched',
				value: formatNum(internalStockOut),
				color: '#06b6d4',
			},
			{
				label: 'Expired',
				value: formatNum(expired),
				color: '#f43f5e',
			},
			{
				label: 'Total Stocked Out',
				value: formatNum(totalStockOut),
				color: '#ef4444',
			},
			{
				label: 'Closing Stock',
				value: formatNum(closingStock),
				color: '#6366f1',
			},
		];
	}, [currentData, selectedTab]);

	return (
		<>
			<BackdropLoader showProgress isLoading={loading} />
			<ImagesFinder
				onSubmit={fetchInventoryData}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className={styles.root}>
				<div className='ml-4 mt-2 flex justify-between items-center'>
					<h2 className='font-bold text-lg'>
						Inventory Analysis History
					</h2>
					<Button
						onClick={() => {
							const params = new URLSearchParams();
							if (filtersValue?.multiStore?.id?.length > 0) {
								params.set(
									'store',
									encodeURIComponent(
										JSON.stringify({
											id: filtersValue.multiStore.id[0],
											name:
												filtersValue.multiStore
													.name?.[0] || '',
										})
									)
								);
							}
							if (filtersValue?.dateRange?.from) {
								params.set(
									'from',
									moment(filtersValue.dateRange.from).format(
										'YYYY-MM-DD'
									)
								);
							}
							if (filtersValue?.dateRange?.to) {
								params.set(
									'to',
									moment(filtersValue.dateRange.to).format(
										'YYYY-MM-DD'
									)
								);
							}
							params.set('tab', 'stock');
							const queryString = params.toString();
							window.open(
								`${urls.EXTENSION}${urls.SKUS_INVENTORY_STOCK}${
									queryString ? `?${queryString}` : ''
								}`
							);
						}}
						className='flex items-center gap-2 px-4 py-2 mr-4 text-yellow-600 bg-transparent bg-opacity-0 border border-gray-300 rounded-md hover:text-yellow-700 flex-shrink-0'
					>
						<ExternalLink className='size-4' /> View Current Stock
					</Button>
				</div>
				{!params.has('s_no_filter') && (
					<div className={styles.header}>
						<div className='flex items-center gap-2 w-full'>
							<div className='flex-1 min-w-[200px]'>
								<SearchBar
									value={query}
									placeholder={PLACE_HOLDERS[searchField]}
									handleInput={handleSearch}
									handleChange={handleSearchBy}
									searchBy={
										SEARCH_BY != null
											? {
													...(SEARCH_BY ?? {}),
													current: searchField,
											  }
											: null
									}
									className='w-full'
								/>
							</div>
							<div className='whitespace-nowrap font-medium text-gray-700 px-2 flex-shrink-0'>
								Total: {currentData.length}
							</div>
							<div className='inline-flex overflow-x-auto rounded-md bg-[#FDE6AD] border border-[#00000033] ml-2 flex-shrink-0'>
								<button
									onClick={() => {
										setFormat('dateWise');
										if (Object.keys(filtersValue).length)
											fetchInventoryData(
												filtersValue,
												'dateWise'
											);
									}}
									className={`px-3.5 py-2 text-sm font-medium rounded-md whitespace-nowrap ${
										format === 'dateWise'
											? 'bg-yellow-400 text-black'
											: 'text-gray-700 hover:bg-yellow-300/50'
									}`}
								>
									Date Wise
								</button>
								<button
									onClick={() => {
										setFormat('productWise');
										if (Object.keys(filtersValue).length)
											fetchInventoryData(
												filtersValue,
												'productWise'
											);
									}}
									className={`px-3.5 py-2 text-sm font-medium rounded-md whitespace-nowrap ${
										format === 'productWise'
											? 'bg-yellow-400 text-black'
											: 'text-gray-700 hover:bg-yellow-300/50'
									}`}
								>
									Product Wise
								</button>
							</div>
						</div>
						<Button
							onClick={(e) => {
								handleFilterDrawerOpen();
							}}
							className='flex items-center justify-center gap-2 h-fit px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700 flex-shrink-0'
						>
							<span className='text-[15px]'>Filter & Export</span>
							<Filter className='size-4' />
						</Button>
					</div>
				)}
				<div className='px-4'>
					<StatsComp
						statsCards={statsSummary?.map((ele) => ({
							...ele,
							value: ele?.amount || ele?.value,
						}))}
					/>
				</div>
				<InvAnalysisListPage
					aiTrue={params.has('s_no_filter')}
					ANALYTICS_TYPE={ANALYTICS_TYPE}
					data={currentData}
					loading={loading}
					filterData={{
						filtersInfo: filtersInfo,
						filtersValue: filtersValue,
					}}
					selectedTab={selectedTab}
					setSelectedTab={setSelectedTab}
					format={format}
				/>
			</div>
		</>
	);
};

INVHistory.defaultProps = {};

const mapStateToProps = (state) => {
	const { DATE_RANGE_FILTER: dateRangeFilter, BRAND_FILTER: brandFilter } =
		state.analytics;
	const { LIST_DATA: data } = state.analytics.INV_ANALYTICS;
	const brandData = state.form.BRANDS.data.LIST;
	const { query: searchQuery, searchBy } =
		state.analytics.BOM_ANALYTICS.SEARCH_DATA;
	return {
		dateRangeFilter,
		searchQuery,
		data,
		searchBy,
		brandData,
		brandFilter,
	};
};

const mapDispatchToProps = {
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	setBomSearchResults: analyticsAction.setBomSearchResults,
	fetchData: analyticsAction.fetchData,
	fetchAiQcData: aiAnalyticsActions.fetchAiQcData,
	toggleModal: modalActions.toggleFilterModal,
	applyFilters: analyticsAction.applyFilters,
	gateway: formActions.gateway,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	exportInvAnalytics: analyticsAction.exportInvAnalytics,
};
export default connect(mapStateToProps, mapDispatchToProps)(INVHistory);
